import { ItemListItemRowData } from "@/components/item-list/types/item-list-row-types";

export enum SidePanelState {
  SPLIT_VIEW = "SPLIT_VIEW",
  MAIN_PANEL_ONLY = "MAIN_PANEL_ONLY",
  SIDE_PANEL_ONLY = "SIDE_PANEL_ONLY",
}

export enum SidePanelTab {
  HEADS_UP = "HEADS_UP",
  MEM_IT = "MEM_IT",
}

export type SidePanelRoute = SidePanelHeadsUpRoute | SidePanelMemItRoute;

export enum SidePanelRouteType {
  HEADS_UP = "HEADS_UP",
  MEM_IT = "MEM_IT",
}

export interface RelatedCard {
  id: string;
  title: string;
  items: ItemListItemRowData[];
}

export type SidePanelHeadsUpRoute = {
  type: SidePanelRouteType.HEADS_UP;
};

export type SidePanelMemItRoute = { type: SidePanelRouteType.MEM_IT; sessionId?: string };

export interface GoToMemItOptions {
  openChatPanel?: boolean;
}
